
// import { motion } from "framer-motion";
// import { FaIdBadge, FaUser, FaPhone, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import InputField from "../components/InputField";
// import loginImg from "../assets/images/amass-pros-login-img.webp";
// import { FaHome } from "react-icons/fa";
// import "./Register.css";
// import "./AuthResponsive.css";

// export default function Register() {
//     const navigate = useNavigate();
//     const [form, setForm] = useState({
//         referralId: "",
//         fullName: "",
//         phoneNumber: "",
//         password: "",
//         confirmPassword: ""
//     });
//     const [errors, setErrors] = useState({});
//     const [touched, setTouched] = useState({});
//     const [showPassword, setShowPassword] = useState(false);
//     const [showConfirmPassword, setShowConfirmPassword] = useState(false);

//     const validateField = (name, value, draftForm) => {
//         const referralRegex = /^AMASS\d{11}$/;
//         const phoneRegex = /^\d{10}$/;
//         const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{6,}$/;

//         if (name === "fullName") {
//             return value.trim() ? "" : "Enter name as per Aadhaar.";
//         }
//         if (name === "referralId") {
//             return referralRegex.test(value.trim()) ? "" : "Format: AMASS06032026001";
//         }
//         if (name === "phoneNumber") {
//             return phoneRegex.test(value.trim()) ? "" : "Enter valid 10-digit mobile.";
//         }
//         if (name === "password") {
//             if (!value) return "Create a password.";
//             return passwordRegex.test(value)
//                 ? ""
//                 : "Min 6 chars with upper, lower, number, special.";
//         }
//         if (name === "confirmPassword") {
//             if (!value) return "Confirm your password.";
//             return value === draftForm.password
//                 ? ""
//                 : "Passwords do not match.";
//         }
//         return "";
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         const nextValue = name === "referralId" ? value.toUpperCase() : value;
//         const nextForm = { ...form, [name]: nextValue };
//         setForm(nextForm);

//         if (touched[name]) {
//             setErrors((prev) => ({ ...prev, [name]: validateField(name, nextValue, nextForm) }));
//         }
//         if ((name === "password" || name === "confirmPassword") && touched.confirmPassword) {
//             setErrors((prev) => ({
//                 ...prev,
//                 confirmPassword: validateField("confirmPassword", nextForm.confirmPassword, nextForm)
//             }));
//         }
//     };

//     const handleFocus = (e) => {
//         const { name } = e.target;
//         setTouched((prev) => ({ ...prev, [name]: true }));
//     };

//     const handleBlur = (e) => {
//         const { name, value } = e.target;
//         setTouched((prev) => ({ ...prev, [name]: true }));
//         setErrors((prev) => ({ ...prev, [name]: validateField(name, value, form) }));
//     };

//     const handleNextStep = () => {
//         const nextErrors = {};
//         const allFields = ["referralId", "fullName", "phoneNumber", "password", "confirmPassword"];

//         allFields.forEach((field) => {
//             const msg = validateField(field, form[field], form);
//             if (msg) nextErrors[field] = msg;
//         });

//         if (Object.keys(nextErrors).length > 0) {
//             setTouched({
//                 referralId: true,
//                 fullName: true,
//                 phoneNumber: true,
//                 password: true,
//                 confirmPassword: true
//             });
//         }

//         setErrors(nextErrors);
//         if (Object.keys(nextErrors).length > 0) return;

//         navigate("/register-otp", {
//             state: {
//                 phoneNumber: form.phoneNumber,
//                 otpNotice: "OTP sent to your registered mobile number. Please enter the code to proceed."
//             }
//         });
//     };

//     return (
//         <div className="auth-container register-auth-container">
//             <div className="auth-left register-auth-left">
//                 <motion.button
//                     whileHover={{ scale: 1.05 }}
//                     onClick={() => navigate("/", { replace: true })}
//                     type="button"
//                     className="back-btn"
//                 >
//                     <FaHome />Home
//                 </motion.button>
//                 <motion.div
//                     initial={{ opacity: 0, y: -20 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.6 }}
//                 >
//                     <h1>Create Account</h1>
//                     <p className="register-subtitle-badge">
//                         Join us today. No registration cost. Free sign up.
//                     </p>
//                 </motion.div>

//                 <motion.div
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     transition={{ duration: 0.6, delay: 0.2 }}
//                 >
//                     <div className="login-form">
//                         <div className="form-field">
//                             <InputField
//                                 icon={<FaIdBadge />}
//                                 placeholder="Referral ID"
//                                 name="referralId"
//                                 value={form.referralId}
//                                 onChange={handleChange}
//                                 onFocus={handleFocus}
//                                 onBlur={handleBlur}
//                             />
//                             {touched.referralId && errors.referralId ? (
//                                 <p className="field-note error">{errors.referralId}</p>
//                             ) : null}
//                         </div>
//                         <div className="form-field">
//                             <InputField
//                                 icon={<FaUser />}
//                                 placeholder="Full Name"
//                                 name="fullName"
//                                 value={form.fullName}
//                                 onChange={handleChange}
//                                 onFocus={handleFocus}
//                                 onBlur={handleBlur}
//                             />
//                             {touched.fullName && errors.fullName ? (
//                                 <p className="field-note error">{errors.fullName}</p>
//                             ) : null}
//                         </div>
//                         <div className="form-field">
//                             <InputField
//                                 icon={<FaPhone />}
//                                 placeholder="Phone Number"
//                                 name="phoneNumber"
//                                 value={form.phoneNumber}
//                                 onChange={handleChange}
//                                 onFocus={handleFocus}
//                                 onBlur={handleBlur}
//                             />
//                             {touched.phoneNumber && errors.phoneNumber ? (
//                                 <p className="field-note error">{errors.phoneNumber}</p>
//                             ) : null}
//                         </div>
//                         <div className="form-field">
//                             <InputField
//                                 icon={<FaLock />}
//                                 type={showPassword ? "text" : "password"}
//                                 placeholder="Create Password"
//                                 name="password"
//                                 autoComplete="new-password"
//                                 value={form.password}
//                                 onChange={handleChange}
//                                 onFocus={handleFocus}
//                                 onBlur={handleBlur}
//                                 rightIcon={showPassword ? <FaEyeSlash /> : <FaEye />}
//                                 onRightIconClick={() => setShowPassword((prev) => !prev)}
//                                 rightAriaLabel={showPassword ? "Hide create password" : "Show create password"}
//                             />
//                             {touched.password && errors.password ? (
//                                 <p className="field-note error">{errors.password}</p>
//                             ) : null}
//                         </div>
//                         <div className="form-field">
//                             <InputField
//                                 icon={<FaLock />}
//                                 type={showConfirmPassword ? "text" : "password"}
//                                 placeholder="Confirm Password"
//                                 name="confirmPassword"
//                                 autoComplete="new-password"
//                                 value={form.confirmPassword}
//                                 onChange={handleChange}
//                                 onFocus={handleFocus}
//                                 onBlur={handleBlur}
//                                 rightIcon={showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
//                                 onRightIconClick={() => setShowConfirmPassword((prev) => !prev)}
//                                 rightAriaLabel={showConfirmPassword ? "Hide confirm password" : "Show confirm password"}
//                             />
//                             {touched.confirmPassword && errors.confirmPassword ? (
//                                 <p className="field-note error">{errors.confirmPassword}</p>
//                             ) : null}
//                         </div>

//                         <motion.button
//                             whileHover={{ scale: 1.02 }}
//                             whileTap={{ scale: 0.98 }}
//                             className="btn"
//                             onClick={handleNextStep}
//                         >
//                             Next Step
//                         </motion.button>
//                     </div>
//                 </motion.div>
//             </div>

//             <div className="auth-right">
//                 <img src={loginImg} alt="Register" className="login-image" />
//             </div>
//         </div>
//     );
// }
import { motion } from "framer-motion";
import {
  FaIdBadge,
  FaUser,
  FaPhone,
  FaLock,
  FaEye,
  FaEyeSlash,
  FaHome,
} from "react-icons/fa";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

import InputField from "../components/InputField";
import loginImg from "../assets/images/amass-pros-login-img.webp";
import "./Register.css";
import "./AuthResponsive.css";

const API = "http://localhost:8080/api/auth/register";

export default function Register() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    referralId: "",
    fullName: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const validateField = (name, value, draftForm) => {
    const referralRegex = /^AMASS\d{11}$/;
    const phoneRegex = /^\d{10}$/;
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{6,}$/;

    if (name === "fullName") {
      return value.trim() ? "" : "Enter name as per Aadhaar.";
    }

    if (name === "referralId") {
      if (!value.trim()) return "";
      return referralRegex.test(value.trim())
        ? ""
        : "Format: AMASS06032026001";
    }

    if (name === "phoneNumber") {
      return phoneRegex.test(value.trim())
        ? ""
        : "Enter valid 10-digit mobile.";
    }

    if (name === "password") {
      if (!value) return "Create a password.";
      return passwordRegex.test(value)
        ? ""
        : "Min 6 chars with upper, lower, number, special.";
    }

    if (name === "confirmPassword") {
      if (!value) return "Confirm your password.";
      return value === draftForm.password ? "" : "Passwords do not match.";
    }

    return "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let nextValue = value;

    if (name === "referralId") {
      nextValue = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    }

    if (name === "phoneNumber") {
      nextValue = value.replace(/\D/g, "").slice(0, 10);
    }

    const nextForm = { ...form, [name]: nextValue };
    setForm(nextForm);

    if (touched[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: validateField(name, nextValue, nextForm),
      }));
    }

    if ((name === "password" || name === "confirmPassword") && touched.confirmPassword) {
      setErrors((prev) => ({
        ...prev,
        confirmPassword: validateField(
          "confirmPassword",
          nextForm.confirmPassword,
          nextForm
        ),
      }));
    }
  };

  const handleFocus = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    setErrors((prev) => ({
      ...prev,
      [name]: validateField(name, value, form),
    }));
  };

  const handleNextStep = async () => {
    const nextErrors = {};
    const allFields = [
      "referralId",
      "fullName",
      "phoneNumber",
      "password",
      "confirmPassword",
    ];

    allFields.forEach((field) => {
      const msg = validateField(field, form[field], form);
      if (msg) nextErrors[field] = msg;
    });

    if (Object.keys(nextErrors).length > 0) {
      setTouched({
        referralId: true,
        fullName: true,
        phoneNumber: true,
        password: true,
        confirmPassword: true,
      });
      setErrors(nextErrors);
      return;
    }

    setErrors({});

    try {
      setLoading(true);

      const payload = {
        referralId: form.referralId.trim()
          ? form.referralId.trim().toUpperCase()
          : null,
        fullName: form.fullName.trim(),
        phone: form.phoneNumber.trim(),
        password: form.password,
      };

      const res = await axios.post(API, payload, {
        headers: { "Content-Type": "application/json" },
        timeout: 20000,
      });

      const data = res?.data || {};

      if (data?.token) localStorage.setItem("token", data.token);
      if (data?.registrationId)
        localStorage.setItem("registrationId", data.registrationId);
      if (data?.referralId)
        localStorage.setItem("referralId", data.referralId);
      if (data?.fullName) localStorage.setItem("fullName", data.fullName);
      localStorage.setItem("phoneNumber", form.phoneNumber.trim());

      await Swal.fire({
        icon: "success",
        title: "Registration Successful",
        html:
          "<b>Your account has been created successfully.</b><br/><br/>" +
          "OTP sent to your registered mobile number.<br/>" +
          "Please enter the code to proceed.",
        confirmButtonText: "Continue",
        confirmButtonColor: "#16a34a",
        allowOutsideClick: false,
      });

      navigate("/register-otp", {
        state: {
          phoneNumber: form.phoneNumber,
          otpNotice:
            "OTP sent to your registered mobile number. Please enter the code to proceed.",
          registrationId: data?.registrationId || "",
          referralId: data?.referralId || form.referralId,
          fullName: data?.fullName || form.fullName,
        },
      });
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        (typeof err?.response?.data === "string" ? err.response.data : null) ||
        err?.message ||
        "Registration failed. Please try again.";

      await Swal.fire({
        icon: "error",
        title: "Registration Failed",
        text: msg,
        confirmButtonText: "Try Again",
        confirmButtonColor: "#ef4444",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container register-auth-container">
      <div className="auth-left register-auth-left">
        <motion.button
          whileHover={{ scale: 1.05 }}
          onClick={() => navigate("/", { replace: true })}
          type="button"
          className="back-btn"
        >
          <FaHome />Home
        </motion.button>

        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1>Create Account</h1>
          <p className="register-subtitle-badge">
            Join us today. No registration cost. Free sign up.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="login-form">
            <div className="form-field">
              <InputField
                icon={<FaIdBadge />}
                placeholder="Referral ID"
                name="referralId"
                value={form.referralId}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
              />
              {touched.referralId && errors.referralId ? (
                <p className="field-note error">{errors.referralId}</p>
              ) : null}
            </div>

            <div className="form-field">
              <InputField
                icon={<FaUser />}
                placeholder="Full Name"
                name="fullName"
                value={form.fullName}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
              />
              {touched.fullName && errors.fullName ? (
                <p className="field-note error">{errors.fullName}</p>
              ) : null}
            </div>

            <div className="form-field">
              <InputField
                icon={<FaPhone />}
                placeholder="Phone Number"
                name="phoneNumber"
                value={form.phoneNumber}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
              />
              {touched.phoneNumber && errors.phoneNumber ? (
                <p className="field-note error">{errors.phoneNumber}</p>
              ) : null}
            </div>

            <div className="form-field">
              <InputField
                icon={<FaLock />}
                type={showPassword ? "text" : "password"}
                placeholder="Create Password"
                name="password"
                autoComplete="new-password"
                value={form.password}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                rightIcon={showPassword ? <FaEyeSlash /> : <FaEye />}
                onRightIconClick={() => setShowPassword((prev) => !prev)}
                rightAriaLabel={
                  showPassword ? "Hide create password" : "Show create password"
                }
              />
              {touched.password && errors.password ? (
                <p className="field-note error">{errors.password}</p>
              ) : null}
            </div>

            <div className="form-field">
              <InputField
                icon={<FaLock />}
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm Password"
                name="confirmPassword"
                autoComplete="new-password"
                value={form.confirmPassword}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                rightIcon={showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                onRightIconClick={() => setShowConfirmPassword((prev) => !prev)}
                rightAriaLabel={
                  showConfirmPassword
                    ? "Hide confirm password"
                    : "Show confirm password"
                }
              />
              {touched.confirmPassword && errors.confirmPassword ? (
                <p className="field-note error">{errors.confirmPassword}</p>
              ) : null}
            </div>

            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="btn"
              onClick={handleNextStep}
              disabled={loading}
              type="button"
            >
              {loading ? "Processing..." : "Next Step"}
            </motion.button>
          </div>
        </motion.div>
      </div>

      <div className="auth-right">
        <img src={loginImg} alt="Register" className="login-image" />
      </div>
    </div>
  );
}
